import { logError } from '@edx/frontend-platform/logging';

export const getErrorStatus = (error) => error?.response?.status ?? error?.status ?? null;

export const logStudioHomeError = (event, error, details = {}) => {
  logError(event, {
    ...details,
    status: getErrorStatus(error),
  });
};
